/**
 * localStorage keys for investor wallet linking only.
 * Asset owner keys live in `../AssetOwner/ownerWalletStorageKeys.js`.
 */
export const INVESTOR_WALLET_STORAGE_KEYS = {
  address: "investor_wallet_address",
  provider: "investor_wallet_provider",
};
